import { and, JsonFormsRendererRegistryEntry, rankWith, uiTypeIs, optionIs } from '@jsonforms/core';
import controlRenderer from './DestinationIpControlRenderer.vue';

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: controlRenderer,
  tester: rankWith(50, and(uiTypeIs('CustomDestinationIp'), optionIs('version', 'v2'))),
};
